import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
export function AudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forItems = ['Enfermeros, meseros y personal de limpieza bajo presión constante.', 'Trabajadores de construcción o bodegas que sienten el peso del agotamiento extremo.', 'Hispanos que sienten que deben ser "perfectos" para no ser juzgados en este país.', 'Cualquier persona que tema quebrarse emocionalmente en un turno de 8 o 10 horas.'];
  const notForItems = ['Personas que buscan un diagnóstico médico o tratamiento psiquiátrico clínico.', 'Quienes no están dispuestos a dedicar 10 segundos a practicar una técnica física.', 'Gente que prefiere seguir sufriendo en silencio sin probar herramientas nuevas.'];
  return <section className="bg-[#0f1b2d] relative" data-id="element-1">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-2">
        <div className="max-w-5xl mx-auto" data-id="element-3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-12" data-id="element-4">
            ¿Es Para Ti?
          </motion.h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-5">
            {/* For */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-gradient-to-br from-[#1a2e4a] to-[#0f1b2d] p-6 md:p-8 rounded-2xl border border-[#3d7a8a]/30" data-id="element-6">
              <h3 className="text-xl md:text-2xl font-bold text-[#a8d8d8] mb-6 flex items-center gap-2" data-id="element-7">
                <CheckIcon className="w-6 h-6" data-id="element-8" />
                Esto ES para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-9">
                {forItems.map((item, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.4,
                delay: 0.3 + index * 0.1
              }} className="flex items-start gap-3" data-id="element-10">
                    <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-11" />
                    <span className="text-gray-200" data-id="element-12">{item}</span>
                  </motion.li>)}
              </ul>
            </motion.div>

            {/* Not For */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-gradient-to-br from-[#1a2e4a] to-[#0f1b2d] p-6 md:p-8 rounded-2xl border border-[#3d7a8a]/30" data-id="element-13">
              <h3 className="text-xl md:text-2xl font-bold text-gray-400 mb-6 flex items-center gap-2" data-id="element-14">
                <XIcon className="w-6 h-6" data-id="element-15" />
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-16">
                {notForItems.map((item, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: 20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.4,
                delay: 0.3 + index * 0.1
              }} className="flex items-start gap-3" data-id="element-17">
                    <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-18" />
                    <span className="text-gray-400" data-id="element-19">{item}</span>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>

      <WaveDivider fillColor="#f8fafc" data-id="element-20" />
    </section>;
}